import React, { useEffect, useState } from 'react';
import Loader from 'Common/Loader';
import { Modal, Accordion, Form, Button } from 'react-bootstrap';
import { Popconfirm } from "antd";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRolePermissionById } from '../services';
import { getUserPermissionById } from 'modules/user-management/user-master/services';

interface Permission {
    id: number;
    name: string;
    code: string;
    isChecked: boolean;
    referenseId: number;
}

interface CategoryPermission {
    category: string;
    permissions: Permission[];
}

interface GroupPermission {
    group: string;
    categoryWisePermissions: CategoryPermission[];
}

interface RolesPermissionProps {
    show: boolean;
    onClose: () => void;
    onSave: (checkedPermissionIds: number[]) => void;
    roleId: any;
    roleName: any;
    flag: string
}

const RolesPermission: React.FC<RolesPermissionProps> = ({ show, onClose, onSave, roleId, roleName, flag }) => {
    const [loading, setLoading] = useState(false);
    const [localPermissions, setLocalPermissions] = React.useState<GroupPermission[]>([]);

    useEffect(() => {
        if (show && roleId) {
            setLoading(true);
            let API_permission;
            if (flag === "Role") {
                API_permission = getRolePermissionById(roleId);
            } else {
                API_permission = getUserPermissionById(roleId);
            }
            API_permission.then((response) => {
                setLocalPermissions(response?.data);
            }).catch((error) => {
                console.error("Failed to fetch permissions:", error);
            }).finally(() => setLoading(false));
        }
    }, [show, roleId]);

    const isCategoryAllChecked = (groupIndex: number, categoryIndex: number): boolean => {
        return localPermissions[groupIndex].categoryWisePermissions[categoryIndex].permissions.every(p => p.isChecked);
    };

    const handleCategoryCheckAll = (groupIndex: number, categoryIndex: number, value: boolean) => {
        const updated = [...localPermissions];
        updated[groupIndex].categoryWisePermissions[categoryIndex].permissions =
            updated[groupIndex].categoryWisePermissions[categoryIndex].permissions.map((perm) => ({
                ...perm,
                isChecked: value,
            }));
        setLocalPermissions(updated);
    };

    const handleToggle = (groupIndex: number, categoryIndex: number, permissionIndex: number) => {
        const updated = [...localPermissions];
        const permission = updated[groupIndex].categoryWisePermissions[categoryIndex].permissions[permissionIndex];
        permission.isChecked = !permission.isChecked;
        setLocalPermissions(updated);
    };

    return (
        <>
            {loading && <Loader />}
            <Modal show={show} onHide={onClose} backdrop="static" centered scrollable={true}>
                <Modal.Header closeButton>
                    <Modal.Title>{roleName}</Modal.Title>
                </Modal.Header>
                {/* <Modal.Body>
                    {loading ? (
                        <Loader />
                    ) : (
                        <>
                            {localPermissions?.map((group, groupIndex) => (
                                <div key={group.group} className="mb-2">
                                    <h5 className="mb-2">{group.group}</h5>
                                    <Accordion defaultActiveKey="0">
                                        {group?.categoryWisePermissions?.map((category, categoryIndex) => (
                                            <Accordion.Item
                                                eventKey={`${groupIndex}-${categoryIndex}`}
                                                key={category.category}
                                            >
                                                <Accordion.Header>{category.category}</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        <Form.Check
                                                            type="switch"
                                                            className='me-2'
                                                            id={`checkall-${groupIndex}-${categoryIndex}`}
                                                            label="All"
                                                            checked={isCategoryAllChecked(groupIndex, categoryIndex)}
                                                            onChange={(e) => handleCategoryCheckAll(groupIndex, categoryIndex, e.target.checked)}
                                                        />
                                                        {" | "}
                                                        {category.permissions.map((perm, permIndex) => (
                                                            <div
                                                                className="form-check form-switch form-check-inline"
                                                                dir="ltr"
                                                                key={perm.id}
                                                            >
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id={`perm-${groupIndex}-${categoryIndex}-${permIndex}`}
                                                                    checked={perm.isChecked}
                                                                    onChange={() => handleToggle(groupIndex, categoryIndex, permIndex)}
                                                                />
                                                                <Form.Label htmlFor={`perm-${groupIndex}-${categoryIndex}-${permIndex}`}>
                                                                    {perm.name}
                                                                </Form.Label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                    {groupIndex !== localPermissions.length - 1 && (
                                        <hr className="my-3 border-top border-3" />
                                    )}
                                </div>
                            ))}
                        </>
                    )}
                </Modal.Body> */}
                <Modal.Body>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-start">Permission</th>
                                        <th>Select All</th>
                                        <th>Read</th>
                                        <th>Write</th>
                                        <th>Delete</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {localPermissions?.flatMap((group, groupIndex) =>
                                        group.categoryWisePermissions.flatMap((category, categoryIndex) => {
                                            // Build permission map
                                            const permissionMap: { [key: string]: Permission } = {};
                                            category.permissions.forEach((perm) => {
                                                permissionMap[perm.code.toLowerCase()] = perm;
                                            });

                                            // Check if all permissions are selected
                                            const isAllSelected = ['read', 'write', 'delete'].every(
                                                (type) => permissionMap[type]?.isChecked
                                            );

                                            const rowKey = `${group.group}-${category.category}`;

                                            return (
                                                <tr key={rowKey}>

                                                    <td className="text-start">{category.category}</td>
                                                    <td>
                                                        <Form.Check
                                                            type="switch"
                                                            id={`selectall-${groupIndex}-${categoryIndex}`}
                                                            checked={isAllSelected}
                                                            onChange={(e) =>
                                                                handleCategoryCheckAll(groupIndex, categoryIndex, e.target.checked)
                                                            }
                                                        />
                                                    </td>

                                                    {['read', 'write', 'delete'].map((permType) => {
                                                        const perm = permissionMap[permType];
                                                        if (!perm) return <td key={permType}>—</td>;

                                                        return (
                                                            <td key={perm.id}>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    checked={perm.isChecked}
                                                                    className="form-check-sm my-1 ps-2 custom-permission-checkbox"
                                                                    onChange={() => {
                                                                        const permIndex = category.permissions.findIndex(
                                                                            (p) => p.id === perm.id
                                                                        );
                                                                        handleToggle(groupIndex, categoryIndex, permIndex);
                                                                    }}
                                                                />


                                                            </td>
                                                        );
                                                    })}

                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex gap-2 justify-content-end mt-4 mb-2">
                        <button className="add-btn" onClick={onClose}>
                            Cancel
                        </button>
                        {flag === "Role" ?
                            <Popconfirm
                                title="Update Role Permissions"
                                description="Modifying the permissions for this role will apply the changes to all users currently assigned to it. Please confirm to proceed with the update."
                                icon={<FontAwesomeIcon className='me-3' icon={faCircleExclamation} />}
                                okText="Update"
                                cancelText="Cancel"
                                okButtonProps={{ className: 'submit-btn' }}
                                cancelButtonProps={{ className: 'add-btn' }}
                                overlayClassName="small-popconfirm"
                                onConfirm={() => {
                                    const checkedPermissionIds = localPermissions?.flatMap(group =>
                                        group?.categoryWisePermissions?.flatMap(category =>
                                            category?.permissions
                                                .filter(p => p.isChecked)
                                                .map(p => p.id)
                                        )
                                    );
                                    onSave(checkedPermissionIds);
                                }}
                            >
                                <button className="submit-btn">
                                    Save
                                </button>
                            </Popconfirm>
                            :
                            <button className="submit-btn" onClick={() => {
                                const checkedPermissionIds = localPermissions?.flatMap(group =>
                                    group?.categoryWisePermissions?.flatMap(category =>
                                        category?.permissions
                                            .filter(p => p.isChecked)
                                            .map(p => p.id)
                                    )
                                );
                                onSave(checkedPermissionIds);
                            }}>
                                Save
                            </button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default RolesPermission;

